import {
  PMSmallNumber,
  PMSmallNumberCardEditSchema,
} from "@pimo/pimo-components/src/lib/pm-components";

import { getLocalizedCardCopy } from "../../../utils/get-localized-card-copy";
import {
  getItemName,
  getPluralOfItemName,
} from "../../../utils/get-plural-of-item-name";
import { isFieldEnabled } from "../../field-enabled";
import { DashboardCardContext } from "../context";

export function addNumberOfCompletedTrackingItemsCard(
  ctx: DashboardCardContext
) {
  const { view, language, projectName, projectNamePlural, getCardCopy } = ctx;

  const numberOfCompletedItemsComponent = view.addComponent({
    component: PMSmallNumber,
    layoutProps: {
      componentId: "numberOfCompletedItemsComponent",
      title: "",
      description: "",
      labels: ["#ofCompletedItems"],
      editSchema: PMSmallNumberCardEditSchema,
    },
  });

  numberOfCompletedItemsComponent.mapLayoutProps(() => {
    return {
      componentId: "numberOfCompletedItemsComponent",
      labels: ["#ofCompletedItems"],
      description: getCardCopy(language, "numberOfCompletedItems").description,
      title: getCardCopy(language, "numberOfCompletedItems").title,
      editSchema: PMSmallNumberCardEditSchema,
    };
  });

  numberOfCompletedItemsComponent.mapState((appState) => {
    return {
      title: getLocalizedCardCopy(appState.language, "numberOfCompletedItems", {
        itemName: getItemName(
          appState.settings?.configuration?.itemName,
          appState.language
        ),
        itemNamePlural: getPluralOfItemName(
          appState.settings?.configuration?.itemName,
          appState.language
        ),
        projectName,
        projectNamePlural,
      }).title,
      number: appState?.dashboard?._calculated?.numberOfClosedSubEntities ?? 0,
    };
  });

  numberOfCompletedItemsComponent.mapVisibility(({ settings }) =>
    isFieldEnabled(settings, "completion", "itemReporting")
  );
}
